var _defs, _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPalmArk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "50 100 270 180",
    height: 200,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "5fa9fdcfcf"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 65.832031 122.910156 L 122.082031 122.910156 L 122.082031 244.601562 L 65.832031 244.601562 Z M 65.832031 122.910156 ",
    clipRule: "nonzero"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -37.5,
    width: 450,
    fill: "#ffffff",
    y: -37.499999,
    height: 449.999989,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5fa9fdcfcf)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 65.832031 122.910156 L 122.082031 122.910156 L 122.082031 244.640625 L 65.832031 244.640625 Z M 65.832031 122.910156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.833562, 229.265845)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M -37.71875 -1.671875 L -37.71875 -11.640625 C -37.71875 -14.648438 -36.742188 -16.796875 -34.796875 -18.078125 C -32.847656 -19.367188 -30 -20.015625 -26.25 -20.015625 C -22.507812 -20.015625 -19.6875 -19.441406 -17.78125 -18.296875 C -15.875 -17.160156 -14.921875 -15.113281 -14.921875 -12.15625 L -14.921875 -9.09375 L 0 -9.09375 L 0 -1.671875 Z M -21.734375 -9.53125 C -21.734375 -10.4375 -21.898438 -11.097656 -22.234375 -11.515625 C -22.578125 -11.941406 -23.0625 -12.222656 -23.6875 -12.359375 C -24.3125 -12.492188 -25.210938 -12.5625 -26.390625 -12.5625 C -27.972656 -12.5625 -29.113281 -12.382812 -29.8125 -12.03125 C -30.507812 -11.675781 -30.859375 -10.972656 -30.859375 -9.921875 L -30.859375 -9.09375 L -21.734375 -9.09375 Z M -21.734375 -9.53125 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.833562, 208.545769)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -0.65625 L -37.71875 -4.296875 L -37.71875 -17.078125 L 0 -20.6875 L 0 -13.515625 L -6.109375 -13 L -6.109375 -8.4375 L 0 -7.984375 Z M -12.125 -9 L -12.125 -12.421875 L -31.3125 -10.75 L -31.3125 -10.40625 Z M -12.125 -9 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.833562, 187.25501)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -1.671875 L -37.71875 -1.671875 L -37.71875 -9.21875 L -6.40625 -9.21875 L -6.40625 -16.984375 L 0 -16.984375 Z M 0 -1.671875 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.833562, 169.827319)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 0 -1.671875 L -37.71875 -1.671875 L -37.71875 -13.171875 L -14.703125 -16.328125 L -37.71875 -19.5 L -37.71875 -31.078125 L 0 -31.078125 L 0 -24.1875 L -27.171875 -24.1875 L 0 -19.84375 L 0 -13.078125 L -27.171875 -8.46875 L 0 -8.46875 Z M 0 -1.671875 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#0cc0df",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.799103, 238.499984)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 1.90625 0 L 12.421875 -108.875 L 49.3125 -108.875 L 59.703125 0 L 39.03125 0 L 37.515625 -17.625 L 24.34375 -17.625 L 23.0625 0 Z M 25.984375 -34.984375 L 35.875 -34.984375 L 31.046875 -90.375 L 30.046875 -90.375 Z M 25.984375 -34.984375 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.275662, 238.499984)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.8125 -108.875 L 38.28125 -108.875 C 43.601562 -108.875 47.722656 -107.671875 50.640625 -105.265625 C 53.554688 -102.859375 55.519531 -99.476562 56.53125 -95.125 C 57.539062 -90.769531 58.046875 -85.210938 58.046875 -78.453125 C 58.046875 -72.285156 57.242188 -67.46875 55.640625 -64 C 54.035156 -60.539062 51.25 -58.132812 47.28125 -56.78125 C 50.570312 -56.101562 52.957031 -54.453125 54.4375 -51.828125 C 55.914062 -49.210938 56.65625 -45.664062 56.65625 -41.1875 L 56.40625 0 L 35.109375 0 L 35.109375 -42.59375 C 35.109375 -45.632812 34.515625 -47.578125 33.328125 -48.421875 C 32.148438 -49.265625 30 -49.6875 26.875 -49.6875 L 26.875 0 L 4.8125 0 Z M 32.1875 -68.578125 C 35.226562 -68.578125 36.75 -71.867188 36.75 -78.453125 C 36.75 -81.328125 36.625 -83.484375 36.375 -84.921875 C 36.125 -86.359375 35.660156 -87.347656 34.984375 -87.890625 C 34.304688 -88.441406 33.332031 -88.71875 32.0625 -88.71875 L 27 -88.71875 L 27 -68.578125 Z M 32.1875 -68.578125 "
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(249.735379, 238.499984)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4.8125 0 L 4.8125 -108.875 L 26.359375 -108.875 L 26.359375 -65.28125 L 36.5 -108.875 L 58.4375 -108.875 L 46.265625 -59.0625 L 60.96875 0 L 38.40625 0 L 26.484375 -52.734375 L 26.484375 0 Z M 4.8125 0 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmArk);
export default __webpack_public_path__ + "static/media/palmArk.6ece845e9cfc1b5858befdfbba1c4797.svg";
export { ForwardRef as ReactComponent };